import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import classes from './DragAndDropStudentList.module.css';
import { submissionStatusEnum, submissionStatusTextEnum } from "../../../../../../models/SubmissionStatusEnum";
import { useSelector } from 'react-redux';

const DragAndDropStudentList = ({ submissionStatus, listId, items, searchTerm, draggableClass }) => {
  const STUDENT_LIST_DROPPABLE_ID = 'studentsList';
  const { texts } = useSelector(state => state.translate);


  const getIsScored = (item = null) => {
    if (submissionStatus == submissionStatusTextEnum.finalScored)
      return true
    else if (listId == STUDENT_LIST_DROPPABLE_ID && item && item.submissionStatus == submissionStatusTextEnum.finalScored)
      return true;
    else
      return false
  }

  return (
    <Droppable droppableId={listId} isDropDisabled={getIsScored()}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className={classes.Droppable}
        >
          {items && items.map((item, index) => (
            <Draggable key={item?.user?.id} draggableId={item?.user?.id} index={index} isDragDisabled={getIsScored(item)}>
              {(provided1, snapshot) => (
                <div
                  ref={provided1.innerRef}
                  {...provided1.draggableProps}
                  {...provided1.dragHandleProps}
                  className={getIsScored(item) ? classes.Disable : snapshot.isDragging ? classes.IsDragging : draggableClass}
                >
                  <div className={classes.Student}>
                    <div className={searchTerm && item.user?.firstName.includes(searchTerm) ? classes.Colored : ''}>
                      {item?.submissionStatus ==submissionStatusTextEnum.finalScored && <div className={classes.Tooltip}>
                        <span className={classes.tooltipText}>{texts.studentIsFinalSubmissionScored}</span>
                      </div>}
                      {item?.user?.firstName} {item?.user?.lastName}</div>
                  </div>
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default DragAndDropStudentList;
